'use client';

import React, {useEffect} from 'react';

export function BrowserConsoleWarning() {
  useEffect(() => {
    console.warn(
      '%c STOP! Potential pasting attack!',
      'background-color: red; padding-top: 5px; padding-bottom: 5px; font-size: 20px; border-radius: 10px; color: white; font-weight: bold;',
    );
    console.warn(
      '%c Pasting code can allow attackers to take over your account. Please do not paste code that you do not understand and trust! ',
      'background-color: red; font-size: 15px; color: white;',
    );
  }, []);
  return <></>;
}
